import type { Module } from "vuex";
import type { z } from "zod";
import { mainMedicalCategoriesSchema } from "./models/mainMedicalCategoriesSchema";
import { apiPaths } from "@/dictionaries/api/paths";
import http from "@/utils/axios";
import { notify } from "@/utils/notify";

export interface MedicalCategories {
  categories:
    | z.infer<typeof mainMedicalCategoriesSchema>["medicalCategories"]
    | null;
}

const module: Module<MedicalCategories, unknown> = {
  namespaced: true,
  state: {
    categories: null,
  },
  getters: {
    getAllCategories: (state): MedicalCategories["categories"] | null =>
      state.categories,
    getCategoryById: (state) => (id: number) => {
      if (state.categories) {
        return state.categories.find((category) => category.id === id);
      }
    },
  },
  mutations: {
    setAllCategories(state, categories: MedicalCategories["categories"]) {
      state.categories = categories;
    },
  },
  actions: {
    async fetchMedicalCategories({ commit, state }) {
      if (state.categories) return state.categories;

      try {
        const response = await http.get<unknown>(
          apiPaths.mainMedicalCategories.exact
        );
        const categories = mainMedicalCategoriesSchema.parse(response.data);
        commit("setAllCategories", categories.medicalCategories);
      } catch {
        notify("error.response_error");
      }
    },
  },
};

export default module;
